module.exports = {
  title: '导萃药房管理系统',
  imgUrl: 'logo.png'
}
